import { NavLink, RichTextValue } from '@/components';
import { formatters, TermsAndConditionsDto } from '@/core';
import { useUserContextSelector } from '@/redux';
import { useGetTermsAndConditionsQuery } from '@/redux/termsAndConditions';
import { Table, Tag } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {}

export function TermsAndConditionsListPanel(props: Props) {
  const { t } = useTranslation();
  const organizationId = useUserContextSelector((x) => x.organizationId?.[0]);

  const { data = [], isFetching } = useGetTermsAndConditionsQuery(
    { organizationId: organizationId! },
    { skip: !organizationId },
  );

  const sorted = useMemo(
    () => [...data].sort((a, b) => b.version - a.version),
    [data],
  );

  const latest = sorted[0];

  const columns = useMemo(
    () => [
      {
        title: t('termsAndConditions.version'),
        dataIndex: 'version',
        key: 'version',
        width: 120,
        render: (_: unknown, record: TermsAndConditionsDto) => (
          <NavLink to={`terms-and-conditions/${record.id}`}>
            {record.version}
          </NavLink>
        ),
      },
      {
        title: t('termsAndConditions.publishDate'),
        dataIndex: 'createdAt',
        key: 'createdAt',
        width: 200,
        render: (createdAt: string) => formatters.dateTime(createdAt),
      },
      {
        title: t('termsAndConditions.status'),
        key: 'status',

        render: (_: unknown, record: TermsAndConditionsDto) =>
          record.id === latest?.id ? (
            <Tag color="green">{t('termsAndConditions.current')}</Tag>
          ) : null,
      },
    ],
    [latest?.id, t],
  );

  if (!latest) {
    return null;
  }

  return (
    <>
      <Table<TermsAndConditionsDto>
        rowKey="id"
        loading={isFetching}
        columns={columns}
        dataSource={sorted}
        pagination={false}
        expandable={{
          expandedRowRender: (record) => (
            <RichTextValue
              label={false}
              value={record.content}
              ownerType="TermsAndConditions"
              ownerId={''}
            />
          ),
          rowExpandable: (record) => Boolean(record.content),
        }}
      />
    </>
  );
}
